exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/deep/.el-tabs__content{height:590px!important}.el-form-item__label{text-align:right!important}.el-dialog__body{padding:20px 30px!important}.mxgrapgTopBtn{position:absolute;right:2%;top:11%}.vxe-body--column{line-height:48px!important}", ""]);

// exports
